export const landlordTermsPath = '/landlord-terms';
